import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";
import { store } from "./store";
import { LicenseInfo } from "@mui/x-license";
import { initializeSelectedProposal } from "./reducers";

store.dispatch(initializeSelectedProposal());
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || "");

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);
